import React, { useState, useEffect } from 'react';
import { format, addDays, parseISO } from 'date-fns';
import { isDateInPast } from '../../utils/appointmentUtils';

const AppointmentDate = ({ practice, nextAvailableDates, formatDateFull, getTodayDateString, onSelectDate }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  
  // Set the selected date when the practice changes
  useEffect(() => {
    if (practice && nextAvailableDates && nextAvailableDates[practice.id]) {
      const practiceDate = nextAvailableDates[practice.id].date;
      // Check if the date is in the past
      if (!isDateInPast(practiceDate)) {
        setSelectedDate(practiceDate);
      } else {
        // If the date is in the past, use today's date
        setSelectedDate(getTodayDateString());
      }
    } else {
      setSelectedDate(getTodayDateString());
    }
  }, [practice, nextAvailableDates, getTodayDateString]);
  
  // Generate a list of dates for the next 14 days
  useEffect(() => {
    const dates = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to beginning of day for comparison
    
    for (let i = 0; i < 14; i++) {
      const date = addDays(today, i);
      const dateString = format(date, 'yyyy-MM-dd');
      dates.push(dateString);
    }
    
    setAvailableDates(dates);
  }, []);
  
  // Handle date selection
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    
    // Check if the selected date is in the past
    if (isDateInPast(newDate)) {
      // If the date is in the past, use today's date instead
      const todayDate = getTodayDateString();
      setSelectedDate(todayDate);
      if (onSelectDate) {
        onSelectDate(todayDate);
      }
    } else {
      // If the date is not in the past, use the selected date
      setSelectedDate(newDate);
      if (onSelectDate) {
        onSelectDate(newDate);
      }
    }
  };
  
  if (!practice) return null;
  
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-2">Select Appointment Date</h3>
      
      <div>
        <label htmlFor="date-select" className="block text-sm font-medium text-gray-700 mb-1">
          Choose a date:
        </label>
        <select
          id="date-select"
          value={selectedDate || ''}
          onChange={handleDateChange}
          className="w-full p-2 border border-gray-300 rounded focus:ring-primary focus:border-primary"
        >
          {availableDates.map(date => (
            <option key={date} value={date}>
              {formatDateFull(date)}
            </option>
          ))}
        </select>
      </div>
      
      <p className="text-gray-700 mt-3">
        <strong>Selected Date:</strong> {formatDateFull(selectedDate || getTodayDateString())}
      </p>
    </div>
  );
};

export default AppointmentDate;
